// extracted by mini-css-extract-plugin
export var postFull = "postFull-module--postFull--1PUD5";
export var postFull_no_video = "postFull-module--postFull_no_video--rz2LI";
export var content = "postFull-module--content--pDJAY";
export var document = "postFull-module--document--3JIB0";
export var video = "postFull-module--video--3132S";
export var navigation = "postFull-module--navigation--9d6jo";
export var prev = "postFull-module--prev--AQH1T";
export var next = "postFull-module--next--3XXGo";
export var play = "postFull-module--play--3sXdq";